import { is } from 'immutable'
import { isEqual } from 'lodash-es'
import { shallowEqual } from 'react-redux'

export const deepCustomEquals = (a: any, b: any) => {
  return a === b || shallowEqual(a, b) || isEqual(a, b) || is(a, b)
}
